import settings from "@/settings";



/**
 * localstorage写入本地缓存
 *
 * @param {*} key key名
 * @param {*} value 值
 */
export function setLocalS(key, value) {
  localStorage.setItem(key, value);
}

/**
 * localstorage获取本地缓存
 *
 * @param {*} key key名
 */
export function getLocalS(key) {
  const res = localStorage.getItem(key);
  if (res && res !== "null") return res;
  else return false;
}

/**
 * localstorage删除本地储存
 *
 * @param {*} key key名
 */
export function delLocalS(key) {
  localStorage.removeItem(key);
}

/**
 * 获取页面标题
 *
 * @param {*} pageTitle 页面标题
 */
export function getPageTitle(pageTitle) {
  const title = settings.sysTitle || "管理后台";

  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return `${title}`;
}

export function WebsiteUrl(){
  return window.location.protocol+"//"+window.location.hostname+(window.location.port == 80?'':':'+window.location.port);
}
